import React, { useMemo } from "react";
import { Modal, Button } from "react-bootstrap";
import { globalStrings } from "../util/translation/languages";
import { previewLinkIcon, UrlPreview } from "../Helpers/chatCommon";
import { useSelector } from "react-redux";
import { timestampToDateTime } from "../Helpers/common";
import AttachmentFiles from "../chatboard/attachmentFile";

const ChatUnpinAlert = (props) => {
  const {
    showUnpin,
    handleClose,
    unpinData,
    userInfo,
    selectedLanguage,
    handleUnpinMessage,
  } = props;
  const allAttendeeList = useSelector((state) => state.call.allAttendeeList);
  const isUserOnline = useMemo(() => {
    return allAttendeeList.find((item) => item.user_id === unpinData.senderID)
      ?.online
      ? true
      : false;
  }, [allAttendeeList, unpinData.senderID]);

  let IsNewLineExist = null;
  if (unpinData.message !== "c2-attach-files") {
    IsNewLineExist = /\r|\n/.exec(unpinData.message);
  }
  const newMessage =
    IsNewLineExist !== null
      ? unpinData.preview &&
        Array.isArray(unpinData.preview) &&
        unpinData.preview.length > 0
        ? unpinData.message_array.join(" ")
        : unpinData.message.replace(/ /g, "&nbsp;")
      : unpinData.message.replace(/ /g, "&nbsp;");

  const lengthOfSplitMessage = newMessage?.split("\n").length;

  return (
    <>
      <Modal show={showUnpin} className="unpin">
        <Modal.Header>
          <Modal.Title>
            {globalStrings[selectedLanguage]?.$removePinnedItem}
          </Modal.Title>
          <button onClick={handleClose} className="icon-close p-0">
            <svg
              width="15.556"
              height="15.556"
              viewBox="2240.448 1762.444 15.556 15.556"
            >
              <path
                d="m2250.727 1766.055-2.5 2.5-2.5-2.5a.786.786 0 0 0-1.112 0l-.555.556a.786.786 0 0 0 0 1.11l2.5 2.5-2.5 2.501a.786.786 0 0 0 0 1.111l.555.556a.786.786 0 0 0 1.111 0l2.5-2.5 2.5 2.5a.786.786 0 0 0 1.112 0l.555-.556a.786.786 0 0 0 0-1.11l-2.5-2.501 2.5-2.5a.786.786 0 0 0 0-1.111l-.555-.556a.786.786 0 0 0-1.111 0Z"
                fill="#2d343f"
              ></path>
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="text-thin">
              {globalStrings[selectedLanguage]?.$removePinnedItemMsg}
            </p>
            <div className="border border-light border-radius p-2">
              <div className="right_s w-100 ml-0">
                <div className="body p-0">
                  <div
                    className={"chat_row mb-0"}
                    id={unpinData.id}
                    key={unpinData.id}
                  >
                    <div className="w-100 d-flex max-w-100">
                      <div className="avatar">
                        {userInfo?.user_profile_image ? (
                          // eslint-disable-next-line jsx-a11y/alt-text
                          <img
                            className="h-100"
                            src={`${userInfo?.user_profile_image}`}
                          ></img>
                        ) : (
                          <svg viewBox="3 2 18 19">
                            <path
                              fill="#425b76"
                              d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                            ></path>
                          </svg>
                        )}
                        <span
                          className={`status ${isUserOnline && "online"}`}
                        ></span>
                      </div>
                      <div
                        className={`bubble inner-bubble ${
                          unpinData.isReply === true && "reply"
                        }`}
                      >
                        {unpinData.isReply === true && (
                          <h3 className="Name-messenger">{userInfo?.name} </h3>
                        )}
                        <div
                          className={`${
                            unpinData.isReply === true && "reply-inner"
                          }`}
                        >
                          {unpinData.isReply === true ? (
                            <h3 className="Name-messenger flex-column align-items-start">
                              <div>
                                <p
                                  className="break-words text-grey"
                                  dangerouslySetInnerHTML={{
                                    __html: unpinData.earlyMessage,
                                  }}
                                />
                                <div className="time ml-0 mt-1">
                                  {allAttendeeList?.find(
                                    (findItem) =>
                                      findItem.user_id ===
                                      unpinData.earlyMsgSenderID,
                                  )?.name ?? ""}
                                  ,{" "}
                                  {timestampToDateTime(
                                    unpinData.earlyMsgTimestamp,
                                  )}
                                </div>
                              </div>
                            </h3>
                          ) : (
                            <h3 className="Name-messenger">
                              {userInfo?.name}
                              <div className="time">
                                {timestampToDateTime(unpinData.timestamp)}
                              </div>
                            </h3>
                          )}

                          {unpinData.attachments !== undefined &&
                          unpinData.attachments.length > 0 &&
                          unpinData.message === "c2-attach-files" ? (
                            <div className="d-flex file_send_info gap-10 flex-wrap">
                              {unpinData.attachments.map(
                                (attachmentItem, attachmentIndex) => (
                                  <div key={attachmentIndex} className="w-100">
                                    {/* eslint-disable-next-line indent */}
                                    {/* eslint-disable-next-line indent */}
                                    <AttachmentFiles
                                      attachmentItem={attachmentItem}
                                      messageDetail={unpinData}
                                    />
                                  </div>
                                ),
                              )}
                            </div>
                          ) : IsNewLineExist !== null ? (
                            <>
                              {newMessage?.split("\n").map((str, index) => (
                                <>
                                  <div
                                    key={index}
                                    className="d-flex file_send_info gap-10 flex-wrap"
                                  >
                                    <p
                                      className="break-words"
                                      dangerouslySetInnerHTML={{ __html: str }}
                                    />
                                    {previewLinkIcon(unpinData)}
                                    {unpinData.edited === true &&
                                      index === lengthOfSplitMessage - 1 && (
                                        <p className="edit_message_display">
                                          (edited)
                                        </p>
                                      )}
                                  </div>
                                </>
                              ))}
                              {unpinData?.preview
                                ? UrlPreview(unpinData?.preview)
                                : null}
                            </>
                          ) : (
                            <>
                              <div className="d-flex file_send_info gap-10 flex-wrap">
                                <p
                                  className="break-words"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      unpinData.preview &&
                                      Array.isArray(unpinData.preview) &&
                                      unpinData.preview.length > 0
                                        ? unpinData.message_array.join(" ")
                                        : unpinData.message,
                                  }}
                                />
                                {previewLinkIcon(unpinData)}
                                {unpinData.edited === true && (
                                  <p className="edit_message_display">
                                    (edited)
                                  </p>
                                )}
                              </div>
                              {unpinData?.preview
                                ? UrlPreview(unpinData?.preview)
                                : null}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-light btn btn-secondary"
            type="cancel"
            id="cancel"
            onClick={handleClose}
          >
            {globalStrings[selectedLanguage]?.$cancel}
          </Button>
          <Button
            className="btn btn-orange btn btn-secondary"
            type="submit"
            id="submit"
            onClick={() => {
              handleUnpinMessage(unpinData);
              handleClose();
            }}
          >
            {globalStrings[selectedLanguage]?.$removePinnedItem}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChatUnpinAlert;
